import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import AvailabilityPage from './AvailabilityPage.js';

export default WithGASetup(AvailabilityPage, AuthContext);
